import { defineMessages } from "react-intl"

export const financingMessages = {
	errors: {
		generic: {
			severity: "error" as const,
			...defineMessages({
				text: {
					defaultMessage: "This information is currently not available.",
					id: "financing.error.generic.text",
				},
				title: {
					defaultMessage: "Technical error.",
					id: "financing.error.generic.title",
				},
			}),
		},
		timeout: {
			severity: "info" as const,
			...defineMessages({
				text: {
					defaultMessage: "This information is currently not available.",
					id: "financing.error.timeout.text",
				},
				title: {
					defaultMessage: "Technical error.",
					id: "financing.error.timeout.title",
				},
			}),
		},
		unauthorized: {
			severity: "info" as const,
			...defineMessages({
				text: {
					defaultMessage: "This information is currently not available.",
					id: "financing.error.unauthorized.text",
				},
				title: {
					defaultMessage: "Technical error.",
					id: "financing.error.unauthorized.title",
				},
			}),
		},
	},
}
